import script from "./ClaimHistory.vue?vue&type=script&setup=true&lang=js"
export * from "./ClaimHistory.vue?vue&type=script&setup=true&lang=js"

import "./ClaimHistory.vue?vue&type=style&index=0&id=0695d7c2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0695d7c2"]])

export default __exports__